export const SITE = {
  name: "Orion Edcon Services",
  domain: "orionedconservices.in",
  tagline: "Architecting Global Futures",
  phone: "+91 93152 72273",
  phoneHref: "tel:+919315272273",
  whatsapp:
    "https://wa.me/919315272273?text=Hello%20Orion%20Edcon%2C%20I%20would%20like%20to%20book%20a%20counselling%20session.",
  email: "sapp4125@gmail.com",
  city: "201 B The Olive Crescent, GH 12, Sector 47, Gurugram 122018",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SERVICES = [
  "Study Abroad — USA",
  "Study Abroad — UK",
  "Study Abroad — Germany",
  "Study Abroad — Latvia",
  "Institutional Setup in India",
  "Twinning / Partnerships",
  "Apprentice Placement",
  "Other",
];

export const DESTINATIONS = ["USA", "UK", "Germany", "Latvia", "Undecided", "Not applicable"];
